export default "__VITE_ASSET__16c1435c__"